import prefill from '../prefill';
import t from '../../translation';

export default prefill({
  0: { text: t('none') },
  1: { text: t('sideswept') },
  2: { text: t('blunt') },
  3: { text: t('wispy') },
  4: { text: t('curly') },
});
